// Module
var code = "<toolbar-color-menu colors=\"parent.elementColors\" menu-type=\"line\" on-select=\"parent.updateStraightLineColor(color)\"> </toolbar-color-menu> ";
// Exports
module.exports = code;